import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import logo from ".././assets/img/logo.png";
import logo from ".././assets/img/logo-white.svg";
import logoBlack from ".././assets/img/logo_black.png";
import polanilogo from "../assets/img/Polanilogo.png";
import { HeaderData } from "./HeaderData";
import MobileNavigation from "./MobileNavigation";

const Header = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0); // Scroll to the top
  };
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // You can adjust this value (100) based on when you want the class to be added
      const scrolled = window.scrollY > 100;
      setIsScrolled(scrolled);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={`main_header_arae ${isScrolled ? "nav-fixed-onscroll" : ""}`}
      >
        <div className="topbar-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6">
                <ul className="topbar-list">
                  <li>
                    <Link to="https://www.facebook.com/PolanisTravels/">
                      <i className="fab fa-facebook"></i>
                    </Link>

                    <Link to="https://www.instagram.com/polanitravels/?igsh=NmVjbnQ5Nm53cDht#">
                      <i className="fab fa-instagram"></i>
                    </Link>
                    {/* <Link to="#!">
                      <i className="fab fa-twitter-square"></i>
                    </Link> */}
                    {/* <Link to="https://www.instagram.com/polanitravels/?igsh=NmVjbnQ5Nm53cDht#">
                      <i className="w-20">
                        <svg
                          className="insta-cus-svg"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z" />
                        </svg>
                      </i>
                    </Link> */}
         

          
<Link to="https://www.youtube.com/@houseofpolanitravel/">
  <i className="fab fa-youtube"></i>
</Link>


                 <Link to="https://www.tiktok.com/@Houseofpolani">
  <i className="w-20">
    <svg
      className="tiktok-cus-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      width="16"
      height="14"
      fill="white"
    >
      <path d="M448,209.09a139.78,139.78,0,0,1-77.44-23.5V329.22a175.46,175.46,0,0,1-175.55,175.4c-26.11,0-52.26-6.33-76.32-18.33-36.5-18.2-63.48-50.62-76.91-89.59A171.59,171.59,0,0,1,32,321.63c0-74.63,48.28-138.53,117.87-160.23a172.77,172.77,0,0,1,57.15-7.65c0,16.32.13,32.63.13,48.94-27.71-1.73-55.41,7.18-78.3,25.88A113.35,113.35,0,0,0,96,322.47c0,61.81,50.07,112.05,111.79,112.05a112.44,112.44,0,0,0,112.57-112.05V0h64A140.07,140.07,0,0,0,448,209.09Z"/>
    </svg>
  </i>
</Link>

                    {/* <Link to="#!">
                      <i className="fab fa-linkedin"></i>
                    </Link> */}
                  </li>
                  <li>
                    <Link to="#!">
                      <span>(021) 32410444</span>
                    </Link>
                  </li>
                  {/*  <li>
                    <Link to="#!">
                      <span>Info@houseofpolani.pk</span>
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div className="col-lg-6 col-md-6">
                <ul className="topbar-others-options">
                  <li>
                    <Link to="/contact-us/">Contact</Link>
                  </li>
                  <li>
                    <a href="mailto:Info@houseofpolani.pk">Info@houseofpolani.pk</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="navbar-area">
          <div className="main-responsive-nav">
            <div className="container">
              <div className="main-responsive-menu">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="logo">
                      <Link onClick={handleLinkClick} to="/">
                        <img
                          style={{ height: "53px", transform: "scale(3.4)" }}
                          src={logo}
                          alt="logo"
                          onClick={handleLinkClick}
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-navbar">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              <Link className="navbar-brand" onClick={handleLinkClick} to="/">
                <img
                  src={logo}
                  style={{ height: "53px", transform: "scale(1.3)" }}
                  alt="logo"
                />
              </Link>
              <div
                className="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav">
                  {HeaderData.map((data, index) => (
                    <li className="nav-item" key={index}>
                      <Link
                        to={data.link}
                        className="nav-link active"
                        onClick={handleLinkClick}
                      >
                        {data.menu}
                        {data.submenu && <i className=""></i>}
                      </Link>
                      {data.submenu && (
                        <ul className="dropdown-menu">
                          {data.subMenuitem.map((item, index1) => (
                            <li className="nav-item" key={index1}>
                              <Link
                                to={item.linkL}
                                className="nav-link"
                                onClick={handleLinkClick}
                              >
                                {item.subItem}
                              </Link>
                              {item.subItems && (
                                <ul className="dropdown-menu">
                                  {item.subItems.map((item1, index2) => (
                                    <li className="nav-item" key={index2}>
                                      <Link
                                        to={item1.link}
                                        className="nav-link"
                                        onClick={handleLinkClick}
                                      >
                                        {item1.item}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                <div className="others-options d-flex align-items-center">
                  {/* <div className="option-item">
                      <a href="#!" className="search-box">
                        <i className="bi bi-search"></i>
                      </a>
                    </div> */}
                  <div className="option-item">
                    <Link
                      to="/inquiry-form/"
                      onClick={handleLinkClick}
                      className="btn  btn_navber"
                    >
                      Instant Inquiry
                    </Link>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div className="others-option-for-responsive">
          <div className="container">
            <div className="dot-menu">
              {/* The button */}
              <button
                className="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h16q.425 0 .713.288T21 17t-.288.713T20 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h16q.425 0 .713.288T21 12t-.288.713T20 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z"
                  ></path>
                </svg>
              </button>

              {/* The offcanvas */}
              <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
              >
                <div className="offcanvas-header">
                  <button
                    className="btn btn-primary"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h16q.425 0 .713.288T21 17t-.288.713T20 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h16q.425 0 .713.288T21 12t-.288.713T20 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z"
                      ></path>
                    </svg>
                  </button>
                </div>
                <MobileNavigation HeaderData={HeaderData} />
              </div>
              <div
                className="offcanvas offcanvas-end"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
              >
                <div className="offcanvas-header-two">
                  <div className="offcanvas-logo">
                    <img src={polanilogo} alt="img" style={{ width: "40%" }} />
                  </div>

                  <div className="offcanvas_off">
                    <button
                      type="button"
                      className="btn-close text-reset"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
                <MobileNavigation HeaderData={HeaderData} />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
